package com.fantasytenis.shared.domain.auth.usecases

import com.fantasytenis.shared.core.utils.SharedData
import com.fantasytenis.shared.core.utils.SharedPrefs
import com.fantasytenis.shared.data.auth.repository.AuthRepository
import com.fantasytenis.shared.domain.auth.entity.UserEntity

/**
 * Login Use Case.
 *
 * Handles user authentication and session management.
 */
class LoginUseCase(
    private val authRepository: AuthRepository,
    private val sharedPrefs: SharedPrefs
) {
    /**
     * Execute login with email and password.
     *
     * @param email User's email
     * @param password User's password
     * @return Result containing UserEntity on success
     */
    suspend operator fun invoke(email: String, password: String): Result<UserEntity> {
        return authRepository.login(email, password)
            .onSuccess { authData ->
                // Store tokens
                sharedPrefs.setAccessToken(authData.accessToken)
                sharedPrefs.setRefreshToken(authData.refreshToken)
                sharedPrefs.setUserId(authData.user.id)

                // Update global state
                SharedData.accessToken.value = authData.accessToken
                SharedData.currentUser.value = authData.user
                SharedData.loggedIn.value = true
            }
            .map { it.user }
    }
}
